import React from 'react';

/**
 * @param {{ title: string, subtitle?: string, level?: 2|3 }} props
 */
export default function AdminSectionHeader({ title, subtitle, level = 2 }) {
  const Tag = level === 3 ? 'h3' : 'h2';
  return (
    <div className="admin-hub-kit-section-head">
      <Tag className="admin-hub-kit-section-head__title">{title}</Tag>
      {subtitle ? <p className="admin-hub-kit-section-head__sub">{subtitle}</p> : null}
    </div>
  );
}
